import Cookies from 'js-cookie';
import { Api, Logout } from '../components/Authenticate/Authenticate';

export const defaultImageUrl = 'data:image/gif;base64,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';

export const getActiveConceptId = (props) => {
    const { redirect } = props || {};
    const activeConceptId = Cookies.get('active_concept_id');
    if (!activeConceptId && redirect) {
        Logout();
    }
    return activeConceptId;
};
export const setActiveConceptId = activeConceptId => Cookies.set('active_concept_id', activeConceptId);

export const currency = (value) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(value); /* $2,500.00 */
};

export const getSelectedIndex = () => {
    const selectedIndex = Cookies.get('selected_index');
    if (selectedIndex === 'undefined' || !selectedIndex) {
        return null;
    }
    return selectedIndex - 0;
};
export const setSelectedIndex = selectedIndex => Cookies.set('selected_index', selectedIndex);


export const updateAccountData = values => new Promise((resolve, reject) => {
    Api()
        .put('merchant-portal/merchant-group/update-account', values)
        .then((response) => {
            resolve(response);
        })
        .catch((e) => {
            reject(e);
        });
});

export const deleteMerchantLogo = ({ activeConceptId }) => new Promise((resolve, reject) => {
    Api()
        .post(`/merchant-portal/merchants/${activeConceptId}/delete-logo`, {})
        .then((response) => {
            resolve(response);
        })
        .catch((e) => {
            reject(e);
        });
});


const getFullMonth = (m) => {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return monthNames[m - 1];
};

export const formatDate = (date, format = 'yyyy-mm-dd') => {
    if (!date) {
        return '';
    }
    const d = new Date(date);
    const year = d.getUTCFullYear();
    let m = `${d.getUTCMonth() + 1}`;
    let day = `${d.getUTCDate()}`;

    if (m.length < 2) m = `0${m}`;
    if (day.length < 2) day = `0${day}`;

    if (format === 'M d, Y') {
        return `${getFullMonth(m)} ${day}, ${year}`;
    }

    if (format === 'yyyy-mm-dd') {
        return [year, m, day].join('-');
    }

    if (format === 'mm/dd/yyyy') {
        return [m, day, year].join('/');
    }
};


// export const updateUserAccount = ({merchantGroupAccountId, user}) => {
//     return new Promise((resolve, reject) => {
//         Api()
//             .put(`/merchant-portal/merchant-group/${merchantGroupAccountId}/update-account`, user)
//             .then(response => resolve(response.data))
//             .catch(e => reject(e));
//     });
// };

// export const getAccountUsers = () => {
//     return new Promise((resolve, reject) => {
//         Api()
//             .get(`merchant-portal/merchant-group/list-accounts`)
//             .then((response) => {
//                 resolve(response.data);
//
//             })
//             .catch(e => {
//                 reject(e);
//             })
//         ;
//     });
// }


// export const getAccountData = (values) => {
//     return new Promise((resolve, reject) => {
//         Api()
//             .get(`merchant-portal/merchant-group/account`, values)
//             .then((response) => {
//                 resolve(response.data);
//
//             })
//             .catch(e => {
//                 reject(e);
//             })
//         ;
//     });
// }


// export const getMerchantDetails = ({activeConceptId}) => {
//
//     return new Promise((resolve, reject) => {
//         Api()
//             .get(`/site/merchant/${activeConceptId}`, {
//             })
//             .then((response) => {
//                 resolve(response);
//
//             })
//         ;
//     });
// }

// export const getReport = ({activeConceptId, page, perPage, reportDateRange}) => {
//
//     return new Promise((resolve, reject) => {
//         const params = {
//             page,
//             perPage,
//             sales_summary_date_start: reportDateRange
//         };
//
//
//
//         // params.sales_summary_date_start = reportDateRange;
//         Api()
//             .get(`/merchant-portal/report/${activeConceptId}`, {
//                 params
//             })
//             .then((response) => {
//
//
//
//                 resolve(response.data.gifts_sold);
//
//             })
//         ;
//     });
//
// }


// export const getDashboard = (params) => {
//
//     return new Promise((resolve, reject) => {
//
//         // params.sales_summary_date_start = reportDateRange;
//         Api()
//             .get('/merchant-portal/dashboard', {
//                 params
//             })
//             .then((response) => {
//
//
//
//
//
//                 const concepts = response.data.merchant_group.concepts.reduce((obj, item) => ({
//                     ...obj,
//                     [item.id]: item
//                 }), {});
//
//                 // Add the details from the activeConcept to the concept object
//                 concepts[response.data.concept.id] = response.data.concept;
//
//
//
//
//                 // setReportData(response.data.concept.sales_summary_by_month.months);
//                 // setReportHasData(response.data.concept.sales_summary_by_month.has_data);
//                 // setShowChecklist({
//                 //     locations: newConcepts[response.data.concept.id] && newConcepts[response.data.concept.id].number_of_locations === 0,
//                 //     logos: newConcepts[response.data.concept.id] && newConcepts[response.data.concept.id].logos.length === 0,
//                 //     photos: newConcepts[response.data.concept.id] && newConcepts[response.data.concept.id].photos.length === 0
//                 // });
//
//
//                 resolve({
//                     activeConcept: response.data.concept,
//                     concepts,
//                     merchantGroup: response.data.merchant_group
//                 });
//
//
//
//             })
//             .catch(e => {
//                 console.log('e',e);
//                 reject();
//             });
//     });
// }